import React, { useState } from 'react';
import { Table, Spinner, Alert, Card, CardBody, CardHeader, Row, Col, Button } from '../../shim/reactstrap';
import apiClient from '../../api/ApiClient';

export const AdminStatistics = () => {
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadStatistics = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiClient.getStatistics();
      setStatistics(data);
    } catch (exc) {
      console.error('Failed to load statistics:', exc);
      setError(exc.message || 'Failed to load statistics');
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => {
    return num?.toLocaleString() || '0';
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Statistics</h2>
        <Button color="primary" onClick={loadStatistics} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Loading...
            </>
          ) : (
            'Refresh'
          )}
        </Button>
      </div>

      {error && (
        <Alert color="danger" className="mb-4" fade={false}>
          <h4>Error</h4>
          <p>{error}</p>
        </Alert>
      )}

      {loading && !statistics && (
        <div className="text-center mt-5">
          <Spinner color="primary" />
          <p className="mt-2">Loading statistics...</p>
        </div>
      )}

      {!statistics && !loading && !error && (
        <Alert color="info" className="text-center" fade={false}>
          <p className="mb-0">Click the Refresh button to load statistics</p>
        </Alert>
      )}

      {statistics && (
        <>
          <Row>
            {/* Tickers with Static Details Checked */}
            <Col md={4} className="mb-4">
              <Card>
                <CardHeader>
                  <h5 className="mb-0">Tickers with Static Details</h5>
                </CardHeader>
                <CardBody>
                  <div className="text-center">
                    <h2 className="display-4 text-primary">
                      {formatNumber(statistics?.TickersWithStaticDetailsChecked)}
                    </h2>
                    <p className="text-muted">Tickers checked</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* Candles by Interval */}
            <Col md={6} className="mb-4">
              <Card>
                <CardHeader>
                  <h5 className="mb-0">Candles by Interval</h5>
                </CardHeader>
                <CardBody>
                  <Table striped>
                    <thead>
                      <tr>
                        <th>Interval</th>
                        <th className="text-end">Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statistics?.CandlesByInterval?.length > 0 ? (
                        statistics.CandlesByInterval.map((item, index) => (
                          <tr key={index}>
                            <td>{item.Interval}</td>
                            <td className="text-end">{formatNumber(item.Count)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="text-center text-muted">
                            No data available
                          </td>
                        </tr>
                      )}
                      {statistics?.CandlesByInterval?.length > 0 && (
                        <tr className="table-active fw-bold">
                          <td>Total</td>
                          <td className="text-end">
                            {formatNumber(
                              statistics.CandlesByInterval.reduce((sum, item) => sum + item.Count, 0)
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>

            {/* Tickers by Type */}
            <Col md={6} className="mb-4">
              <Card>
                <CardHeader>
                  <h5 className="mb-0">Tickers by Type</h5>
                </CardHeader>
                <CardBody>
                  <Table striped>
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th className="text-end">Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statistics?.TickersByType?.length > 0 ? (
                        statistics.TickersByType.map((item, index) => (
                          <tr key={index}>
                            <td>{item.Type}</td>
                            <td className="text-end">{formatNumber(item.Count)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="text-center text-muted">
                            No data available
                          </td>
                        </tr>
                      )}
                      {statistics?.TickersByType?.length > 0 && (
                        <tr className="table-active fw-bold">
                          <td>Total</td>
                          <td className="text-end">
                            {formatNumber(
                              statistics.TickersByType.reduce((sum, item) => sum + item.Count, 0)
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

